/** Public commercial defaults shared by every customer-facing surface. */
export const ASPEN_PRICING = {
  freeLifetimeInbound: 20,
  freeLifetimeOutbound: 20,
  referralBonusInbound: 20,
  referralBonusOutbound: 20,
  paidMonthlyTexts: 300,
  paidMonthlyPriceUsd: 12,
  paidPlanName: 'Aspen Plus',
} as const;

export const ASPEN_PRICE_LABEL = `$${ASPEN_PRICING.paidMonthlyPriceUsd}/month`;
